import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';

import {
  betStore,
  parseQuery,
  ApiServices,
  ApiServiceTypes,
  TranslationContext,
  DefaultQueryParams,
} from '@pascal/pascal-core';

import { loadingStore } from '../../store/loadingStore';

import { soundService } from '../../services/soundService';
import { useAssetsLoadedState } from '../../hooks/useAssetsLoadedState';

import { RtlLanguages } from '../../enums/rtlLanguages.enum';
import { AppDefaultValuesEnum } from '../../enums/appDefaultValues';
import { gameDrawer } from '../../game/drawers/gameDrawer';

export let bodyRef;

export const LoadingContainer = observer(({ children }) => {
  const { updateLoading } = loadingStore;
  const { repliedBetData } = betStore;
  const [translations, setTranslations] = useState({});
  useAssetsLoadedState(bodyRef);

  useEffect(async () => {
    const query = parseQuery(window.location.search);
    bodyRef = document.querySelector('body');
    const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
    const partnerId = query[DefaultQueryParams.PartnerId];
    if (RtlLanguages.includes(lang)) {
      document.documentElement.setAttribute('dir', 'rtl');
    }
    const {
      data: { result },
    } = await ApiServices.get(ApiServiceTypes.TranslationService).getTranslations({
      applicationId: AppDefaultValuesEnum.APPLICATION_ID,
      code: lang,
      partnerId,
    });

    if (result) {
      updateLoading({ isTranslationsLoaded: true });
      setTranslations(result);
    } else {
      const {
        data: { result: defaultTranslations },
      } = await ApiServices.get(ApiServiceTypes.TranslationService).getTranslations({
        applicationId: AppDefaultValuesEnum.APPLICATION_ID,
        code: AppDefaultValuesEnum.LANGUAGE,
        partnerId,
      });
      setTranslations(defaultTranslations);
      updateLoading({ isTranslationsLoaded: true });
    }

    await soundService.init({ language: lang });
    updateLoading({ isSoundLoaded: true });
  }, []);

  useEffect(() => {
    if (repliedBetData) {
      gameDrawer
        .execute({
          mode: 'web',
          scene: 'Main',
          prevScene: null,
        })
        .then(() => {
          updateLoading({ isPixiLoaded: true });
        });
      updateLoading({ isGameInitialLoaded: true });
    }
  }, [repliedBetData]);

  return <TranslationContext.Provider value={translations}>{children}</TranslationContext.Provider>;
});
